import { render, staticRenderFns } from "./HighLow5s.vue?vue&type=template&id=13c60d0c&scoped=true"
import script from "./HighLow5s.vue?vue&type=script&lang=js"
export * from "./HighLow5s.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c60d0c",
  null
  
)

export default component.exports